var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Emitter } from "pixi-particles";
import { TypeCollider, } from "../assetBundles/artConfigBuildings";
import { buildingCalloutGetConfig, IdBuildingCalloutType, } from "../assetBundles/buildingCalloutGetConfig";
import { IdOrientation } from "../constants/IdOrientation";
import { configParticlesBuildingCelebrationBlue, configParticlesBuildingCelebrationBlueGlow, } from "../features/animation/particles/configParticlesBuildingCelebrationBlue";
import { getRecipeIcon } from "../features/generic/icon/getRecipeIcon";
import { utilAnimation } from "../utils/animation/utilAnimation";
import { utilDraw } from "../utils/graphics/utilDraw";
import { utilGrid } from "../utils/grid/utilGrid";
import { utilBuildings } from "../utils/utilBuildings";
import { utilEnvironment } from "../utils/utilEnvironment";
var Circle = PIXI.Circle;
var Container = PIXI.Container;
var Graphics = PIXI.Graphics;
var Point = PIXI.Point;
var Polygon = PIXI.Polygon;
var Rectangle = PIXI.Rectangle;
var Sprite = PIXI.Sprite;
export var BF2_ASSET_SCALE = 1;
export var L_SHAPE_OFFSET = 1;
export var MIN_DISTANCE = 60;
export var MAX_DISTANCE = 80;
export var BF2GetConfigBasedBuilding = function (data, config) {
    var proto = data.proto;
    var assets = config.assets.map(function (cfg) { return BF2CreateAsset(cfg); });
    var container = new Container();
    container.interactive = true;
    container.interactiveChildren = false;
    container.hitArea = BF2CreateHitArea(config.colliders, assets[0].position, container, false);
    // @ts-ignore
    container.addChild.apply(container, assets);
    if (utilEnvironment.isDevelopment()) {
        container.addChild(new Graphics()
            .beginFill(0x7e00ff)
            .drawCircle(0, 0, 3)
            .endFill());
    }
    if (proto.flipped) {
        container.scale.x = container.scale.x * -1;
    }
    return container;
};
var BF2GetBuildingCalloutContainer = function (data, assets, colliders) {
    var container = new Container();
    var height = utilBuildings.hasFinishedConstruction(data) ? 10 : 6;
    var pos = utilBuildings.getHoverPositionOnMap(data, height);
    container.interactive = true;
    container.interactiveChildren = false;
    container.position.set(pos.x, pos.y);
    if (colliders) {
        container.hitArea = BF2CreateHitArea(colliders, new Point(0, 0), container);
    }
    if (assets.length > 0) {
        container.addChild.apply(container, assets);
    }
    if (container.children.length === 0) {
        return;
    }
    return container;
};
export var BF2GetBuildingDiscountCallout = function (data) {
    var config = buildingCalloutGetConfig(IdBuildingCalloutType.Discount);
    var assets = config.map(function (cfg) { return BF2CreateAsset(cfg); });
    var colliders = config[0].colliders;
    return BF2GetBuildingCalloutContainer(data, assets, colliders);
};
export var BF2GetConfigBasedBuildingCallout = function (data) {
    var config = [];
    if (utilBuildings.isUnderConstruction(data)) {
        // TODO: Show callout running in progress
    }
    else if (utilBuildings.hasFinishedProduction(data)) {
        var recipe = data.production.recipe;
        var iconId = getRecipeIcon(recipe);
        config = buildingCalloutGetConfig(IdBuildingCalloutType.FinishedProduction, iconId);
    }
    else if (utilBuildings.hasFinishedConstruction(data)) {
        config = buildingCalloutGetConfig(IdBuildingCalloutType.FinishedConstruction);
    }
    else if (data.production === undefined && data.balancing.idleIcon != undefined) {
        var iconId = data.balancing.idleIcon;
        config = buildingCalloutGetConfig(IdBuildingCalloutType.Idle, iconId);
    }
    var assets = config.map(function (cfg) { return BF2CreateAsset(cfg); });
    var colliders = config.length > 0 ? config[0].colliders : undefined;
    if (assets.length === 0 && !colliders) {
        return undefined;
    }
    return BF2GetBuildingCalloutContainer(data, assets, colliders);
};
export var BF2CreateHitArea = function (colliders, offset, container, flipped) {
    if (colliders.length === 0) {
        return new Rectangle(0, 0, 0, 0);
    }
    // TODO: implement multiple collider support
    var collider = colliders[0];
    var flippedMultiplier = flipped ? -1 : 1;
    switch (collider.type) {
        case TypeCollider.Box:
            var _a = collider, size = _a.size, boxOffset = _a.offset;
            // Debug
            if (utilEnvironment.isDevelopment()) {
                var rectGraphics_1 = new Graphics()
                    .lineStyle(1, 0x7e00ff)
                    .drawRect(boxOffset[0] * BF2_ASSET_SCALE + offset.x, boxOffset[1] * BF2_ASSET_SCALE + offset.y, size[0] * BF2_ASSET_SCALE, size[1] * BF2_ASSET_SCALE);
                if (container) {
                    setTimeout(function () { return container.addChild(rectGraphics_1); }, 1);
                }
            }
            return new Rectangle(boxOffset[0] * BF2_ASSET_SCALE + offset.x, boxOffset[1] * BF2_ASSET_SCALE + offset.y, size[0] * BF2_ASSET_SCALE, size[1] * BF2_ASSET_SCALE);
        case TypeCollider.Circle:
            var _b = collider, radius = _b.radius, circleOffset = _b.offset;
            // Debug
            if (utilEnvironment.isDevelopment()) {
                var circleGraphics_1 = new Graphics()
                    .lineStyle(1, 0x7e00ff)
                    .drawCircle(circleOffset[0] * BF2_ASSET_SCALE + offset.x, circleOffset[1] * BF2_ASSET_SCALE + offset.y, radius * BF2_ASSET_SCALE);
                if (container) {
                    setTimeout(function () { return container.addChild(circleGraphics_1); }, 1);
                }
            }
            return new Circle(circleOffset[0] + offset.x, circleOffset[1] + offset.y, radius * BF2_ASSET_SCALE);
        case TypeCollider.Polygon:
            var _c = collider, points = _c.points, polygonOffset_1 = _c.offset;
            // Debug
            if (utilEnvironment.isDevelopment()) {
                var polyGraphics_1 = utilDraw.drawShape(new Graphics(), {
                    area: 1,
                    borderAlpha: 1,
                    borderColor: 0x7e00ff,
                    borderWidth: 1,
                    points: points.map(function (p) { return [
                        // Multiplier not applied, because the container will get scaled
                        (p[0] + polygonOffset_1[0]) * BF2_ASSET_SCALE + offset.x,
                        (p[1] + polygonOffset_1[1]) * BF2_ASSET_SCALE + offset.y,
                    ]; }),
                });
                if (container) {
                    setTimeout(function () { return container.addChild(polyGraphics_1); }, 1);
                }
            }
            return new Polygon(points.map(function (p) {
                return new Point(((p[0] + polygonOffset_1[0]) * BF2_ASSET_SCALE + offset.x) *
                    flippedMultiplier, (p[1] + polygonOffset_1[1]) * BF2_ASSET_SCALE + offset.y);
            }));
    }
};
export var BF2AddProductionAnim = function (config, animator, offsetRandomly) {
    if (animator) {
        utilAnimation.getAnimLoaded$(config.id).subscribe(function () {
            var anim = utilAnimation.getSpineAnimation(config.id);
            anim.scale.set(config.scale * BF2_ASSET_SCALE, Math.abs(config.scale * BF2_ASSET_SCALE));
            if (config.anchor) {
                anim.pivot.set(anim.width * config.anchor[0], anim.height * config.anchor[1]);
            }
            else {
                // By default, all building assets are positioned with them having anchor in center
                anim.pivot.set(anim.width * 0.5, anim.height * 0.5);
            }
            // Hide hat slots for now
            var hatSlot = anim.skeleton.slots.find(function (slot) { return slot.data.name.toLowerCase() === "hat"; });
            if (hatSlot != undefined && hatSlot.currentSprite instanceof PIXI.spine.SpineSprite) {
                hatSlot.currentSprite.visible = false;
            }
            var LShapeOffset = utilGrid.mapToScreen(L_SHAPE_OFFSET, L_SHAPE_OFFSET);
            anim.position.set(config.offset[0] * BF2_ASSET_SCALE + LShapeOffset.x, config.offset[1] * BF2_ASSET_SCALE + LShapeOffset.y);
            animator.addAnimation(anim, config.anims, offsetRandomly);
        });
    }
};
export var BF2AddBuildingCelebrationAnim = function (container, position) {
    configParticlesBuildingCelebrationBlue.pos.x = position.x;
    configParticlesBuildingCelebrationBlue.pos.y = position.y;
    configParticlesBuildingCelebrationBlueGlow.pos = configParticlesBuildingCelebrationBlue.pos;
    var configParticlesBuildingCelebrationRed = __assign({}, configParticlesBuildingCelebrationBlue, { color: {
            end: "#ff0000",
            start: "#ffd4d4",
        }, pos: {
            x: position.x + MAX_DISTANCE + Math.random() * MIN_DISTANCE,
            y: position.y - MAX_DISTANCE + Math.random() * MIN_DISTANCE,
        } });
    var configParticlesBuildingCelebrationRedGlow = __assign({}, configParticlesBuildingCelebrationBlueGlow, { color: {
            end: "#ff0000",
            start: "#ff0000",
        }, pos: configParticlesBuildingCelebrationRed.pos });
    var configParticlesBuildingCelebrationYellow = __assign({}, configParticlesBuildingCelebrationBlue, { color: {
            end: "#ffe600",
            start: "#fcffd6",
        }, pos: {
            x: position.x - MAX_DISTANCE + Math.random() * MIN_DISTANCE,
            y: position.y - MAX_DISTANCE + Math.random() * MIN_DISTANCE,
        } });
    var configParticlesBuildingCelebrationYellowGlow = __assign({}, configParticlesBuildingCelebrationBlueGlow, { color: {
            end: "#fff700",
            start: "#fff700",
        }, pos: configParticlesBuildingCelebrationYellow.pos });
    var delayArr = [Math.random(), Math.random(), Math.random()];
    StartBuildingCelebrationAnim(container, configParticlesBuildingCelebrationBlue, delayArr[0]);
    StartBuildingCelebrationAnim(container, configParticlesBuildingCelebrationBlueGlow, delayArr[0]);
    StartBuildingCelebrationAnim(container, configParticlesBuildingCelebrationRed, delayArr[1]);
    StartBuildingCelebrationAnim(container, configParticlesBuildingCelebrationRedGlow, delayArr[1]);
    StartBuildingCelebrationAnim(container, configParticlesBuildingCelebrationYellow, delayArr[2]);
    StartBuildingCelebrationAnim(container, configParticlesBuildingCelebrationYellowGlow, delayArr[2]);
};
export var StartBuildingCelebrationAnim = function (container, animConfig, delay) {
    var particleImageEmber = PIXI.Texture.fromImage(require("../assets/particles/ember.png"));
    var emitter = new Emitter(container, particleImageEmber, animConfig);
    utilAnimation.startParticleAnimation(emitter, false, false, delay);
};
export var BF2CreateAsset = function (asset, offsetByLShape, scale) {
    if (offsetByLShape === void 0) { offsetByLShape = true; }
    if (scale === void 0) { scale = BF2_ASSET_SCALE; }
    var sprite = Sprite.fromFrame(asset.id);
    // All building assets are scaled down, same as in BFMH
    sprite.scale.set(scale, scale);
    if (asset.anchor) {
        sprite.anchor.set(asset.anchor[0], asset.anchor[1]);
    }
    else {
        // By default, all building assets are positioned with them having anchor in center
        sprite.anchor.set(0.5, 0.5);
    }
    var LShapeOffset = utilGrid.mapToScreen(L_SHAPE_OFFSET, L_SHAPE_OFFSET);
    if (asset.offset && asset.offset.length > 0) {
        sprite.position.set(asset.offset[0] * scale, asset.offset[1] * scale);
    }
    if (offsetByLShape) {
        sprite.position.x += LShapeOffset.x;
        sprite.position.y += LShapeOffset.y;
    }
    return sprite;
};
export var BF2IsPathExpansion = function (pos, baseSetup) {
    return pos.x / baseSetup.expansionsSizeX === baseSetup.expansionsX - 3;
};
export var BF2PositionSurroundingCorner = function (sprite, orientation, baseSetup) {
    switch (orientation) {
        case IdOrientation.Left:
            var leftPos = utilGrid.mapToScreen(0, baseSetup.expansionsSizeY);
            sprite.x += leftPos.x;
            sprite.y += leftPos.y;
            break;
        case IdOrientation.Right:
            sprite.scale.x *= -1;
            var rightPos = utilGrid.mapToScreen(baseSetup.expansionsSizeX, 0);
            sprite.x += rightPos.x;
            sprite.y += rightPos.y;
            break;
        case IdOrientation.Up:
            var upPos = utilGrid.mapToScreen(baseSetup.expansionsSizeX, baseSetup.expansionsSizeY);
            sprite.x += upPos.x;
            sprite.y += upPos.y;
            break;
        case IdOrientation.Down:
            break;
    }
};
export var BF2PositionSurroundingPiece = function (display, orientation, nudge, baseSetup) {
    switch (orientation) {
        case IdOrientation.Left:
            display.scale.x *= -1;
            var leftPos = utilGrid.mapToScreen(0, nudge);
            display.x += leftPos.x;
            display.y += leftPos.y;
            break;
        case IdOrientation.Right:
            display.scale.x *= -1;
            var rightPos = utilGrid.mapToScreen(baseSetup.expansionsSizeX, nudge);
            display.x += rightPos.x;
            display.y += rightPos.y;
            break;
        case IdOrientation.Up:
            var upPos = utilGrid.mapToScreen(nudge, baseSetup.expansionsSizeY);
            display.x += upPos.x;
            display.y += upPos.y;
            break;
        case IdOrientation.Down:
            var downPos = utilGrid.mapToScreen(nudge, 0);
            display.x += downPos.x;
            display.y += downPos.y;
            break;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/BF2BuildingGraphicsUtils.ts
// module id = 96
// module chunks = 3